// extracted by mini-css-extract-plugin
module.exports = {"slidebar":"SlideBar_slidebar__1MruM"};